export default __webpack_public_path__ + "static/media/16.3cda5ff2.png";